/// <reference path="ListenerManager.js" />

class DOMAttached {
	constructor(el, options) {
		this.listenerManager = new ListenerManager();
		this.options = options;
		this.el = document.getElementById(el);

		if (!this.el) {
			throw new Error(`The element ${el} could not be found to initialize ${this.constructor.name}`);
		}

		this.safeObserve(window, 'unload', this.onUnload.bind(this));
	}

	onUnload(ev) {
		this.listenerManager.onUnload();

		// Unlink the DOM element
		this.el = null;
	}

	safeObserve(el, evStr, func) {
		this.listenerManager.safeObserve(el, evStr, func);
	}

	stopObserve(el, evStr) {
		this.listenerManager.stopObserve(el, evStr);
	}

	stopObserveAllListeners(el) {
		this.listenerManager.stopObserveAllListeners(el);
	}

	registerUnloadAction(func) {
		this.listenerManager.registerUnloadAction(func);
	}

	removeElement(el) {
		this.purge(el);
		el.remove();
	}

	purge(d) {
		var a = d.attributes,
			i, l, n;
		if (a) {
			l = a.length;
			for (var i = 0; i < l; i += 1) {
				n = a[i].name;
				if (typeof d[n] === 'function') {
					d[n] = null;
				}
			}
		}
		a = d.childNodes;
		if (a) {
			l = a.length;
			for (var i = 0; i < l; i += 1) {
				this.purge(d.childNodes[i]);
			}
		}
	}
}
